/**
 * WorkItem Relation Tab Names for identify parent tab
 */

export enum WorkItemRelationTabNames {
    /**
     * Represents a constant string identifier for the WorkItemType
     */
    WORK_ITEM_TYPE = "WorkItemType",

    /**
     * Represents a constant string identifier for the WorkItemCategory
     */
    WORK_ITEM_CATEGORY = "WorkItemCategory",

    /**
     * Represents a constant string identifier for the WorkItemPriority
     */
    WORK_ITEM_PRIORITY = "WorkItemPriority",

    /**
     * Represents a constant string identifier for the WorkItemTab
     */
    WORK_ITEM_TAB = "WorkItemTab",

    /**
     * Represents a constant string identifier for the WorkItemTab
     */
    UNIVERSAL_FIELD = "UniversalField"
}